import React, { useState } from 'react';
import support from '../../Assets/support.jpg';
import "./support.css";

import { Button, DatePicker, Form, Input, InputNumber, TimePicker, message } from 'antd';
import dayjs from 'dayjs';
import { useNavigate } from 'react-router';

const formItemLayout = {
  labelCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 6,
    },
  },
  wrapperCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 14,
    },
  },
};

const Support = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [startTime, setStartTime] = useState(null);
  const apiUrl = process.env.REACT_APP_API_URL;


  const onStartTimeChange = (time) => {
    setStartTime(time);

  };

  const onFinish = async (values) => {
    const today = dayjs().startOf("day");

    if (values.tarih.isBefore(today)) {
      message.error("Onarım tarihi geçmiş bir tarih olamaz!");
      return;
    }

    try {
      setLoading(true);
      const response = await fetch(`${apiUrl}/api/support`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          firstName: values.isim,
          lastName: values.soyisim,
          message: values.mesaj,
          blockNum: values.blok,
          phoneNumber: values.telefon,
          repairDate: values.tarih.format("YYYY-MM-DD"),
          startTime: values.baslangicSaati.format("HH:mm"),
          endTime: values.bitisSaati.format("HH:mm"),
        }),
      });

      if (response.ok) {
        message.success("Destek kaydı başarıyla oluşturuldu!");
        navigate("/");
      } else {
        const data = await response.json();
        message.error("Oluşturma başarısız: " + data.error);
      }
    } catch (error) {
      console.error("Hata:", error);
      message.error("Bir hata oluştu.");
    } finally {
      setLoading(false);
    }
  };



  return (
    <>
      <div className="support">
        <div className="support-background">
          <img src={support} alt="" />
        </div>

        <div className="form-title">
          <h2>Probleminizi Yazın Anında Çözüm Sunalım</h2>
        </div>

        <div className="form-support">
          <Form
            {...formItemLayout}
            form={form}
            style={{ width: "100%" }}
            initialValues={{
              variant: "filled",
            }}
       
            onFinish={onFinish}
          >
            <Form.Item
              label="İsim"
              name="isim"
              rules={[
                {
                  required: true,
                  message: "Lütfen isminizi giriniz!",
                },
                {
                  min: 2,
                  message: "İsim en az 2 karakter olmalıdır!",
                },
              ]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              label="Soyisim"
              name="soyisim"
              rules={[
                {
                  required: true,
                  message: "Lütfen soyisminizi giriniz!",
                },
                {
                  min: 2,
                  message: "Soyisim en az 2 karakter olmalıdır!",
                },
              ]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              label="Talep"
              name="mesaj"
              rules={[
                {
                  required: true,
                  message: "Lütfen mesajınızı giriniz!",
                },
                {
                  min: 30,
                  message: "Mesaj en az 10 karakter olmalıdır!",
                },
              ]}
            >
              <Input.TextArea rows={6} />
            </Form.Item>

            <Form.Item
              label="Blok Numarası"
              name="blok"
              rules={[
                {
                  required: true,
                  message: "Lütfen blok numaranızı giriniz!",
                },
                {
                  type: "number",
                  min: 1,
                  message: "Blok numarası 1 veya daha büyük bir sayı olmalıdır!",
                },
              ]}
            >
              <InputNumber />
            </Form.Item>

            <Form.Item
              label="Telefon"
              name="telefon"
              rules={[
                {
                  required: true,
                  message: "Lütfen telefon numaranızı giriniz!",
                },
                {
                  pattern: /^(0(\d{10})|(\+90\d{10}))$/,
                  message: "Geçerli bir telefon numarası giriniz!",
                },
              ]}
            >
              <Input placeholder='başa 0 veya +90 koymayı unutmayınız' />
            </Form.Item>

            <Form.Item
              label="Onarım Tarihi"
              name="tarih"
              rules={[
                {
                  required: true,
                  message: "Lütfen bir tarih seçiniz!",
                },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || !value.isBefore(dayjs(), "day")) {
                      return Promise.resolve();
                    }
                    return Promise.reject("Geçmiş bir tarih seçilemez!");
                  },
                }),
              ]}
            >
              <DatePicker />
            </Form.Item>
            <Form.Item
              label="Başlangıç Saati"
              name="baslangicSaati"
              rules={[
                {
                  required: true,
                  message: "Lütfen başlangıç saatini seçiniz!",
                },
              ]}
            >
              <TimePicker
                format="HH:mm"
                onChange={onStartTimeChange}
              />
            </Form.Item>

            <Form.Item
              label="Bitiş Saati"
              name="bitisSaati"
              rules={[
                {
                  required: true,
                  message: "Lütfen bitiş saatini seçiniz!",
                },
              ]}
            >
              <TimePicker
                format="HH:mm"
                disabledTime={() => ({
                  disabledHours: () =>
                    Array.from({ length: 24 }, (_, i) => i).filter(
                      (hour) => startTime && hour <= startTime.hour()
                    ),
                  disabledMinutes: (selectedHour) =>
                    startTime && selectedHour === startTime.hour()
                      ? Array.from({ length: 60 }, (_, i) =>
                        i < startTime.minute() ? i : null
                      ).filter((minute) => minute !== null)
                      : [],
                })}
              />
            </Form.Item>

            <Form.Item
                 wrapperCol={{
                  xs: { offset: 0, span: 24 }, 
                  sm: { offset: 6, span: 16 }, 
                }}
            >
              <Button type="primary" htmlType="submit" loading={loading}>
                Gönder
              </Button>
            </Form.Item>
          </Form>
        </div>

        <div className="support-form-warning">
          <p>Formu doldurduktan sonra ekibimiz sizinle en kısa sürede iletişime geçecektir</p>
        </div>
      </div>
    </>
  );
};

export default Support;
